module.exports = {
  NODE_ENV: '"production"',
  APP_ID: JSON.stringify(process.env.APP_ID),
  SERVER_URL: JSON.stringify(process.env.SERVER_URL),
  PUBLIC_URL: JSON.stringify(process.env.PUBLIC_URL)
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 234
// module chunks = 1